import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Donadornt = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col-12'>
                    <div className='transparencia_title'>
                        <h1>Sin Donador No Hay Transplante</h1>
                    </div>
                    <p className='text-justify'>Para miles de pacientes, recibir un trasplante es la única opción de tratamiento médico posible. Enfermedades crónicas degenerativas afectan cada día a un mayor número de personas y no es raro que al final de muchos esfuerzos lo único que les puede mejorar sea un trasplante. Los órganos para trasplante solo se pueden obtener a través de la donación gracias a la solidaridad de las personas que deciden dar sus órganos para trasplantarlos a alguien más. Hoy dos maneras de donar:</p>
                    <ul>
                      <li>En vida</li>
                      <li>Después de morir.</li>
                    </ul>
                    <p>
                      La Ley General de Salud establece que al morir todos podemos ser donadores, aún cuando en vida no hayamos expresado nuestro consentimiento y siempre que nuestros familiares acepten. No todas las personas que fallecen pueden ser donadoras de órganos. Los órganos se obtienen únicamente cuando existe el diagnóstico de muerte encefálica, que, de acuerdo a ley general de salud se considera perdida de la vida.
                      Los órganos que puedes donar después de pérdida de la vida son: Corazón, riñones, pulmones, hígado y páncreas. Si falleces por paro cardio-respiratorio existe la posibilidad de poder donar tejidos: córneas, huesos y piel.
                    </p>
                </div>
            </div>

        </div>
    )
}

export default Donadornt